export default __webpack_public_path__ + "ee39295902a55347be0b5b34e8dffc08.png";